<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Eventos Reproductivos
      <span class="text-gray-500 text-base font-normal ml-2">
        ({{ animal.arete }} - {{ animal.nombre }})
      </span>
    </h1>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
        </select>
      </search-filter>

      <div class="flex gap-2">
        <inertia-link class="btn-indigo" :href="route('animales.edit', animal.id)">
          <span>Volver</span>
          <span class="hidden md:inline">Animal</span>
        </inertia-link>

        <button class="btn-indigo" type="button" @click="openModal = true">
          <span>Registrar</span>
          <span class="hidden md:inline">Evento</span>
        </button>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Fecha</th>
          <th class="px-6 pt-6 pb-4">Método</th>
          <th class="px-6 pt-6 pb-4">Macho</th>
          <th class="px-6 pt-6 pb-4">Semen</th>
          <th class="px-6 pt-6 pb-4">Resultado</th>
          <th class="px-6 pt-6 pb-4">Observaciones</th>
        </tr>

        <tr v-for="e in eventos.data" :key="e.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4">{{ e.fecha_evento || '-' }}</td>
          <td class="border-t px-6 py-4">{{ (e.metodo_reproduccion && e.metodo_reproduccion.nombre) ?
            e.metodo_reproduccion.nombre : '-' }}</td>
          <td class="border-t px-6 py-4">{{ e.macho_texto || '-' }}</td>
          <td class="border-t px-6 py-4">{{ e.semen_codigo || '-' }}</td>
          <td class="border-t px-6 py-4">{{ e.resultado_inicial || '-' }}</td>
          <td class="border-t px-6 py-4">{{ e.observaciones || '-' }}</td>
        </tr>

        <tr v-if="eventos.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">No hay eventos reproductivos registrados</td>
        </tr>
      </table>
    </div>

    <pagination class="mt-6" :links="eventos.links" />

    <!-- MODAL -->
    <div v-if="openModal" class="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" @click="closeModal"></div>

      <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl">
        <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
          <div class="font-bold">Registrar Evento Reproductivo</div>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
        </div>

        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="eForm.fecha_evento" :error="eForm.errors.fecha_evento"
              class="pr-6 pb-8 w-full lg:w-1/3" label="Fecha Evento" type="date" required />

            <select-input v-model="eForm.metodo_reproduccion_id" :error="eForm.errors.metodo_reproduccion_id"
              class="pr-6 pb-8 w-full lg:w-2/3" label="Método Reproducción" required>
              <option :value="null" disabled>Seleccione</option>
              <option v-for="m in metodos" :key="m.id" :value="m.id">
                {{ m.nombre }}
              </option>
            </select-input>

            <select-input v-model="eForm.macho_id" :error="eForm.errors.macho_id" class="pr-6 pb-8 w-full lg:w-1/2"
              label="Macho (opcional)">
              <option :value="null">Seleccione</option>
              <option v-for="m in machos" :key="m.id" :value="m.id">
                {{ (m.arete ? m.arete + ' - ' : '') + (m.nombre || 'Sin nombre') }}
              </option>
            </select-input>

            <text-input v-model="eForm.semen_codigo" :error="eForm.errors.semen_codigo"
              class="pr-6 pb-8 w-full lg:w-1/2" label="Código Semen (opcional)" />

            <select-input v-model="eForm.tecnico_id" :error="eForm.errors.tecnico_id" class="pr-6 pb-8 w-full lg:w-1/2"
              label="Técnico">
              <option :value="null">Seleccione</option>
              <option v-for="t in tecnicos" :key="t.id" :value="t.id">
                {{ t.nombre }}
              </option>
            </select-input>

            <text-input v-model="eForm.toro_donante_id" :error="eForm.errors.toro_donante_id"
              class="pr-6 pb-8 w-full lg:w-1/3" label="Toro Donante ID (opcional)" type="number" />

            <text-input v-model="eForm.resultado_inicial" :error="eForm.errors.resultado_inicial"
              class="pr-6 pb-8 w-full lg:w-1/3" label="Resultado Inicial" placeholder="Ej: SERVIDA / IA / MONTA" />

            <text-input v-model="eForm.observaciones" :error="eForm.errors.observaciones" class="pr-6 pb-8 w-full"
              label="Observaciones" />
          </div>

          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="eForm.processing" class="btn-indigo" type="submit">
              Guardar Evento
            </loading-button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Eventos Reproductivos' },
  components: {
    Pagination,
    SearchFilter,
    TextInput,
    SelectInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    animal: Object,
    filters: [Object, Array],
    eventos: Object,
    metodos: Array,
    machos: Array,
    tecnicos: Array,
  },
  data() {
    return {
      openModal: false,
      form: {
        search: this.filters && this.filters.search ? this.filters.search : null,
        trashed: this.filters && this.filters.trashed ? this.filters.trashed : null,
      },
      eForm: this.$inertia.form({
        fecha_evento: null,
        metodo_reproduccion_id: null,
        macho_id: null,
        semen_codigo: null,
        tecnico_id: null,
        toro_donante_id: null,
        resultado_inicial: null,
        observaciones: null,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          this.route('animales.eventos_reproductivos', { animal: this.animal.id }),
          pickBy(this.form),
          { preserveState: true }
        )
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closeModal() {
      this.openModal = false
      this.eForm.clearErrors()
    },
    store() {
      this.eForm.post(this.route('animales.eventos_reproductivos.store', { animal: this.animal.id }), {
        preserveScroll: true,
        onSuccess: () => {
          this.openModal = false
          this.eForm.reset()
        },
      })
    },
  },
}
</script>